import axios from "axios";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  compareBranch(projectId, from, to) {
    return this.request().get(`/projects/${projectId}/repository/compare`, {
      params: {
        from: from,
        to: to,
      },
    });
  },
  getDemoDeployments(projectId) {
    return new Promise((resolve) => {
      this.request()
        .get(`projects/${projectId}/jobs`, {
          params: {
            scope: ["success", "running"],
            per_page: 20,
          },
        })
        .then((response) => {
          const sortedJobs = response.data
            .sort((a,b) => new Date(b.pipeline.updated_at) - new Date(a.pipeline.updated_at))
            .find((item) => (item.stage === "demo" || item.stage === 'deploy') && (item.name !== 'Storybook Deploy'));
        
          resolve(sortedJobs);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  getJobs(projectId, scope) {
    return this.request().get(`projects/${projectId}/jobs`, {
      params: {
        scope: scope,
        per_page: 50,
      },
    });
  },
  getPipelineVariables(projectId, pipelineId) {
    return this.request().get(`projects/${projectId}/pipelines/${pipelineId}/variables`);
  },
  getTags(projectId) {
    return this.request().get(`projects/${projectId}/repository/tags`, {
      params: {
        order_by: "updated",
      },
    });
  },
  getMergeRequests(projectId, state) {
    return this.request().get(`projects/${projectId}/merge_requests`, {
      params: {
        state: state,
        order_by: "updated_at",
      },
    });
  },
  getThemePackage(projectId, themeName, branch = "master") {
    return this.request().get(
      `projects/${projectId}/repository/files/${themeName}-theme%2Fpackage.json/raw`,
      {
        params: {
          ref: branch,
        },
      }
    );
  },
  compareBranches(projectId, from, to) {
    return this.request().get(`/projects/${projectId}/repository/compare`, {
      params: {
        from: from,
        to: to,
      },
    });
  },
  getSiteThemePackage(projectId, branch = "develop") {
    return this.request().get(
      `projects/${projectId}/repository/files/package.json/raw`,
      {
        params: {
          ref: branch,
        },
      }
    );
  },
  getSiteGatsbyCoreThemePackageFromLockFile(projectId, branch = "develop") {
    return this.request().get(
      `projects/${projectId}/repository/files/yarn.lock/raw`,
      {
        params: {
          ref: branch,
        },
      }
    );
  },
  triggerDeploy(projectId, token, site, branch = "master") {
    var formdata = new FormData();
    formdata.append("ref", branch);
    formdata.append("token", token);
    formdata.append("variables[PIPELINE]", "content-demo-trigger");
    formdata.append("variables[SITE_NAME]", site);

    return this.request().post(`projects/${projectId}/trigger/pipeline`, formdata);
  },
  getCoverage(projectId) {
    return new Promise((resolve) => {
      this.request()
        .get(`projects/${projectId}/jobs`, {
          params: {
            scope: "success",
            per_page: 100,
          },
        })
        .then((response) => {
          let value = "";
          const jobs = response.data.find(
            (item) => item.coverage && item.stage === "test"
          );
          value = jobs ? jobs.coverage : null;
          resolve(value);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  getEnvFile(projectId, branch = "develop") {
    return new Promise((resolve) => {
      this.request()
        .get(`projects/${projectId}/repository/files/.env.development?ref=${branch}`)
        .then((response) => {          
          resolve(response);
        })
        .catch(() => {
          resolve(false);
        });
    });
  },
  request() {
    return axios.create({
      baseURL: "https://gitlab.com/api/v4",
      params: {
        private_token: "glpat-FseDW8sahAtE4kBE7fwLGW86MQp1OmRweGxjCw.01.121do37op",
      },
    });
  },
};
